import React from "react";
import logoSrc from "@/assets/trustdime-logo.png";

/**
 * TrustDime brand mark — square blue/gold split with the wordmark.
 *
 * Pass `height` in px to control vertical size. Width auto-scales.
 * Set `monogram` to render a square version (for tight headers / avatars).
 */
export default function Logo({ height = 28, className = "", monogram = false }) {
  const style = monogram
    ? { height, width: height, objectFit: "cover", objectPosition: "left center" }
    : { height, width: "auto" };
  return (
    <img
      src={logoSrc}
      alt="TrustDime"
      style={style}
      className={className}
      data-testid="brand-logo"
      draggable={false}
    />
  );
}
